"use client"; // Etkileşim (onMouseEnter vs) olduğu için client component yapıyoruz

import { Building, MapPin, Navigation } from "lucide-react";

// Dışarıdan gelecek settings verisinin tipi
interface OfficeInfoProps {
    settings?: {
        address?: string | null;
        [key: string]: any;
    } | null;
}

export default function OfficeInfo({ settings }: OfficeInfoProps) {
    // Adresi al, yoksa varsayılanı kullan
    const address = settings?.address || "Maslak Mahallesi, Büyükdere Cad. No:123, Sky Tower Kat:15, 34398 Şişli/İstanbul";

    // Adresi URL formatına uygun hale getirerek Google Maps linki oluştur (Çok kullanışlı!)
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 md:p-8">
            <div className="flex items-center mb-6">
                <div
                    className="w-10 h-10 rounded-xl flex items-center justify-center mr-4 shadow-sm"
                    style={{ backgroundColor: 'color-mix(in srgb, var(--color-primary), transparent 90%)', color: 'var(--color-primary)' }}
                >
                    <Building className="h-5 w-5" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 tracking-tight">Merkez Ofis</h3>
            </div>

            <div className="space-y-5">
                <p className="text-slate-600 text-sm md:text-base leading-relaxed font-medium">
                    {address}
                </p>

                {/* Tıklanabilir Harita Önizleme Kutusu */}
                <a
                    href={mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block rounded-xl overflow-hidden border border-slate-100 relative group cursor-pointer outline-none shadow-sm hover:shadow-md transition-shadow"
                >
                    <div
                        className="w-full h-32 flex items-center justify-center transition-transform duration-700 group-hover:scale-105"
                        style={{ background: 'linear-gradient(to bottom right, color-mix(in srgb, var(--color-primary), transparent 95%), color-mix(in srgb, var(--color-primary), transparent 85%))' }}
                    >
                        <div className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center group-hover:-translate-y-2 transition-transform duration-300">
                            <MapPin className="h-6 w-6" style={{ color: 'var(--color-primary)' }} />
                        </div>
                    </div>
                </a>

                {/* Akıllı Haritada Göster Butonu */}
                <a
                    href={mapUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full py-3.5 rounded-xl text-sm font-bold transition-all flex items-center justify-center gap-2 group outline-none"
                    style={{
                        backgroundColor: 'color-mix(in srgb, var(--color-primary), transparent 92%)',
                        color: 'var(--color-primary)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'color-mix(in srgb, var(--color-primary), transparent 85%)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'color-mix(in srgb, var(--color-primary), transparent 92%)';
                    }}
                >
                    <Navigation size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    Haritada Göster
                </a>
            </div>
        </div>
    );
}